// Dependencies
import React from 'react';
import {
  isIE,
  isYandex,
  isChrome,
  isSafari,
  isFirefox,
  isEdge,
  isOpera,
  browserVersion,
} from 'react-device-detect';

// Components
import Container from '../container/container';

// Styles
import OldBrowserNoticeStyles from './oldBrowserNotice.styles';

export default function OldBrowserNotice() {
  let supported = true;

  if (isIE || isYandex) supported = false;

  if (isChrome && browserVersion < 10) supported = false;

  if (isSafari && browserVersion < 10) supported = false;

  if (isFirefox && browserVersion < 74) supported = false;

  if (isEdge && browserVersion < 80) supported = false;

  if (isOpera && browserVersion < 66) supported = false;

  if (supported) return '';

  return (
    <OldBrowserNoticeStyles>
      <Container flex alignItems="center" justifyContent="center">
        <h6 className="heading">
          Your browser or browser version is currently unsupported, please
          upgrade for the best experience possible.
        </h6>
      </Container>
    </OldBrowserNoticeStyles>
  );
}
